export default function sortMenuByStationOptions(
  menu = [],
  stationOptions = [],
) {
  const groupOrderMap = {};
  (stationOptions || []).forEach((g, idx) => {
    const name = g?.group?.group_name || g?.group_name || g?.group?.name;
    if (name) groupOrderMap[name] = idx;
  });

  return (menu || []).slice().sort((a, b) => {
    const ai = groupOrderMap[a.group_name] ?? 9999;
    const bi = groupOrderMap[b.group_name] ?? 9999;
    return ai - bi;
  });
}
